const videoControls = function () {
    document.querySelectorAll(".wp-block-video video").forEach(videoEl => {

        videoEl.removeAttribute("controls");

        const wrapper = document.createElement("div");
        wrapper.className = "custom-video-wrapper";
        videoEl.parentNode.insertBefore(wrapper, videoEl);
        wrapper.appendChild(videoEl);

        const controls = document.createElement("div");
        controls.className = "video-controls";
        controls.innerHTML = `
            <button class="video-play is-paused"></button>
            <div class="video-progress"><span></span></div>
            <div class="video-time">00:00 / 00:00</div>
            <button class="video-mute is-unmuted" aria-label="mute/unmute"></button>
        `;
        wrapper.appendChild(controls);

        const preview = videoEl.closest(".wp-block-video")?.querySelector(".preview");
        if (preview) {
            wrapper.appendChild(preview);
        }

        const playBtn = controls.querySelector(".video-play");
        const muteBtn = controls.querySelector(".video-mute");
        const progressBar = controls.querySelector(".video-progress span");
        const progressEl = controls.querySelector(".video-progress");
        const timeDisplay = controls.querySelector(".video-time");

        function formatTime(sec) {
            if (!sec || isNaN(sec)) return "00:00";
            const m = Math.floor(sec / 60);
            const s = Math.floor(sec % 60);
            return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
        }

        videoEl.addEventListener("loadedmetadata", () => {
            timeDisplay.textContent = `00:00 / ${formatTime(videoEl.duration)}`;
        });

        function playVideo() {
            videoEl.play();
        }

        playBtn.addEventListener("click", () => {
            if (videoEl.paused) {
                playVideo();
            } else {
                videoEl.pause();
            }
        });

        if (preview) {
            preview.addEventListener("click", playVideo);
        }

        videoEl.addEventListener("play", () => {
            playBtn.classList.remove("is-paused");
            playBtn.classList.add("is-playing");

            if (preview) preview.classList.add("is-hidden");

            startHideTimer();
        });

        videoEl.addEventListener("pause", () => {
            playBtn.classList.remove("is-playing");
            playBtn.classList.add("is-paused");
            clearTimeout(hideTimeout);
            controls.classList.remove("hidedown");
        });

        videoEl.addEventListener("ended", () => {
            playBtn.classList.remove("is-playing");
            playBtn.classList.add("is-paused");
            clearTimeout(hideTimeout);
            controls.classList.remove("hidedown");

            if (preview) preview.classList.remove("is-hidden");
            videoEl.currentTime = 0;
        });

        videoEl.addEventListener("timeupdate", () => {
            const percent = (videoEl.currentTime / videoEl.duration) * 100;
            progressBar.style.width = percent + "%";
            timeDisplay.textContent =
                `${formatTime(videoEl.currentTime)} / ${formatTime(videoEl.duration)}`;
        });

        progressEl.addEventListener("click", e => {
            const rect = progressEl.getBoundingClientRect();
            const pos = (e.clientX - rect.left) / rect.width;
            videoEl.currentTime = pos * videoEl.duration;
        });

        muteBtn.addEventListener("click", () => {
            videoEl.muted = !videoEl.muted;
            muteBtn.classList.toggle("is-muted", videoEl.muted);
            muteBtn.classList.toggle("is-unmuted", !videoEl.muted);
        });

        let hideTimeout;

        function startHideTimer() {
            clearTimeout(hideTimeout);
            hideTimeout = setTimeout(() => {
                if (!videoEl.paused) controls.classList.add("hidedown");
            }, 2500);
        }

        wrapper.addEventListener("mousemove", () => {
            controls.classList.remove("hidedown");
            if (!videoEl.paused) startHideTimer();
        });

        wrapper.addEventListener("mouseleave", () => {
            if (!videoEl.paused) controls.classList.add("hidedown");
        });

        controls.classList.remove("hidedown");
    });
};

export default videoControls;
